import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { useTranslation } from '@lyearn/i18n';
import { Skeleton, Stack, Typography } from '@lyearn/ui';

import Warnings from '../Warning';
import { TimezoneProps } from './types';

const LazyTimezoneSelect = dynamic(
  () => import(/* webpackPreload: true */ /* webpackChunkName: "timezones" */ './Timezone'),
);

function TimeZone(props: TimezoneProps) {
  const { t } = useTranslation();
  const { value, setFieldValue, disabled, warnings } = props;

  return (
    <Stack className="-mt-16 mb-16 ps-8" direction="col">
      <Stack className="truncate">
        <Typography
          className="flex-shrink-0 me-8"
          color="text-text-secondary"
          variant="body-short-02">
          {t('Common:TimeZone')}:
        </Typography>
        <Suspense
          fallback={<Skeleton animation="wave" height={24} variant="rectangular" width="100%" />}>
          <LazyTimezoneSelect disabled={disabled} setFieldValue={setFieldValue} value={value} />
        </Suspense>
      </Stack>
      <Warnings warnings={warnings} />
    </Stack>
  );
}

export default TimeZone;
